<template>
  <div class="production-batch-counters">
    <div class="counters-group">
      <div
        v-for="counter in stages"
        :key="counter.key"
        class="counter"
        :class="{ 'is-active': counter.key === activeKey, 'is-empty': !counter.value }"
        @click="select(counter)">
        <span class="counter-label">{{ counter.label }}</span>
        <span class="counter-value" :class="`is-${counter.type || 'default'}`">{{ counter.value }}</span>
      </div>
    </div>

    <div class="counters-group is-exceptions" v-if="exceptions.length > 0">
      <div
        v-for="counter in exceptions"
        :key="counter.key"
        class="counter"
        :class="{ 'is-active': counter.key === activeKey, 'is-empty': !counter.value }"
        @click="select(counter)">
        <span class="counter-label">{{ counter.label }}</span>
        <span class="counter-value-row">
          <span class="counter-value" :class="`is-${counter.type || 'default'}`">{{ counter.value }}</span>
          <span class="counter-hint" v-if="counter.hint">{{ counter.hint }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'production-batch-counters',
  props: {
    stages: {
      type: Array,
      default: () => [],
    },
    exceptions: {
      type: Array,
      default: () => [],
    },
    activeKey: {
      type: String,
      default: null,
    },
  },
  methods: {
    select(counter) {
      if (!counter.value) return;

      this.$emit('select', counter.key === this.activeKey ? null : counter.key);
    },
  },
};
</script>

<style lang="scss" scoped>
.production-batch-counters {
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;

  // Each group keeps its cells on one line but shrinks freely; when the row can no longer fit both
  // groups the exceptions block wraps onto its own line instead of cropping.
  .counters-group {
    display: flex;
    align-items: stretch;
    flex: 1 1 420px;
    min-width: 0;
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    overflow: hidden;

    &.is-exceptions {
      flex: 1 1 240px;
      background: #FAFAFA;
    }
  }

  .counter {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1 1 0;
    min-width: 0;
    padding: 12px 14px;
    cursor: pointer;
    text-align: left;
    border-right: 1px solid #EBEEF5;
    transition: background-color 0.2s;

    &:last-child {
      border-right: none;
    }

    &:hover {
      background-color: #F5F7FA;
    }

    &.is-active {
      background-color: #ECF5FF;
      box-shadow: inset 0 -2px 0 0 #409EFF;
    }

    &.is-empty {
      cursor: default;

      &:hover {
        background-color: transparent;
      }
    }
  }

  // Two lines of room so the values stay on the same baseline across cells once a longer label
  // such as "Produtos selecionados" wraps.
  .counter-label {
    font-size: 12px;
    color: #909399;
    line-height: 16px;
    min-height: 32px;
    overflow-wrap: break-word;
  }

  .counter-value-row {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 2px 7px;
  }

  .counter-value {
    font-size: 20px;
    font-weight: 500;
    line-height: 26px;
    color: #303133;

    &.is-primary { color: #409EFF; }
    &.is-success { color: #67C23A; }
    &.is-danger { color: #F56C6C; }
    &.is-warning { color: #E6A23C; }
    &.is-muted { color: #C0C4CC; }
  }

  .counter-hint {
    font-size: 12px;
    color: #909399;
  }
}
</style>
